export default __webpack_public_path__ + "static/media/video-2.1b5c0a94.mp4";